import { Link } from 'react-router';

import { useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { Tag, Typography } from '@cfa/react-components';

import Constants from 'constants/index';

import { updateDocumentPersistedAtom } from '@/atoms/document-persisted';

interface SubcategoryDocumentProps {
  className?: string;
  'data-testid'?: string;
  id: string;
  name: string;
  icon?: string;
  openInNewTab?: boolean;
  rightSideContent?: React.ReactNode;
  onClick?: () => void;
  onNavigate?: () => void;
}

const SubcategoryDocument = ({
  id,
  name,
  icon = '',
  onClick,
  onNavigate,
  openInNewTab = false,
  rightSideContent = null,
  'data-testid': DataTestId = '',
  className = '',
}: SubcategoryDocumentProps) => {
  const { t } = useTranslation();
  const updateDocument = useSetAtom(updateDocumentPersistedAtom);

  return (
    <>
      {onClick ? (
        <button
          type="button"
          className="flex cursor-pointer flex-row items-center justify-between text-left"
          onClick={onClick}
        >
          <div className="group flex flex-row items-center justify-start gap-3 p-4 text-left">
            <img
              className="w-[30px] rounded-none"
              alt="Document Icon"
              src={`${Constants.PATHWAY_CDN_IMG.PROCEDURES}${icon}.svg`}
            />
            <Typography data-testid="SubcategoryDocument" variant="body1">
              {name}
            </Typography>
            <Tag
              className="hidden! group-hover:block!"
              label={t('TrainingPlans.preview')}
            />
          </div>
          {rightSideContent}
        </button>
      ) : (
        <Link
          className={className}
          data-testid={DataTestId}
          onClick={() => {
            updateDocument({ routedFrom: 'browse' });
            onNavigate?.();
          }}
          rel={openInNewTab ? 'noopener noreferrer' : ''}
          target={openInNewTab ? '_blank' : '_self'}
          to={`/doc/${id}`}
        >
          <div className="flex cursor-pointer flex-row items-center justify-between">
            <div className="flex flex-row items-center justify-start gap-3 p-4 text-left">
              <img
                className="w-[30px] rounded-none"
                alt="Document Icon"
                src={`${Constants.PATHWAY_CDN_IMG.PROCEDURES}${icon}.svg`}
              />
              <Typography data-testid="SubcategoryDocument" variant="body1">
                {name}
              </Typography>
            </div>
            {rightSideContent}
          </div>
        </Link>
      )}
    </>
  );
};

export default SubcategoryDocument;
